import { Component, Input, OnInit } from '@angular/core';
import { NbTagComponent } from '@nebular/theme';
import { Observable, of } from 'rxjs';

import { TagView } from 'nr-common';
import { map } from 'rxjs/operators';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'nr-tag-selector',
    templateUrl: './tag-selector.component.html',
    styleUrls: ['./tag-selector.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: TagSelectorComponent
        }
    ],
    standalone: false
})
export class TagSelectorComponent implements ControlValueAccessor {

  private _tags: TagView[] = [];
  get tags(): TagView[] {
    return this._tags;
  }
  @Input() set tags(value: TagView[]) {
    this._tags = value;
    this.filteredTags$ = of(this.tags);
  }
  
  @Input() size = "small";

  constructor() { }

  writeValue(tags: TagView[]): void {
    this.selectedTags = tags || [];
  }

  touched = false;
  onChange = (value) => {};
  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  onTouched = () => {};
  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }
  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  disabled = false;
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  
  public getTagUiOptions(tag: TagView): any {
    if(tag == null) return null;
    const j = JSON.parse(tag.uiOptions);
    return { color: j.color, backgroundColor: j.bgColor};
  }

  // #region Tag autocomplete management
  public filteredTags$: Observable<TagView[]>;
  public selectedTags: TagView[] = [];
  public tagSearchKey: string = null;
  private findTagByName(tagsList: TagView[], tagName: string): {tag: TagView, index: number} {
    if(tagName == null) return null;
    const ind = tagsList.findIndex(t => t.tag?.toLowerCase() == tagName.toLowerCase());
    if(ind === -1) return null;
    return { tag: tagsList[ind], index: ind };
  }
  private tagIsSelected(tag: TagView): boolean {
    return this.selectedTags.findIndex(t => t.id == tag.id) !== -1;
  }
  private filter(value: string): TagView[] {
    const filterValue = value.toLowerCase();
    return this.tags.filter(t => t.tag.toLowerCase().includes(filterValue) && !this.tagIsSelected(t));
  }
  private getFilteredTags(value: string): Observable<TagView[]> {
    return of(value)
      .pipe(
        map(f => this.filter(f)),
      );
  }
  private updateFiltersFormTagsValue() {
    this.onChange(this.selectedTags);
  }
  public onFilterChanged(value: string) {
    this.filteredTags$ = this.getFilteredTags(value);
  }
  public onTagRemoved(tagToRemove: NbTagComponent) { 
    if(tagToRemove == null) return;
    
    this.markAsTouched();

    // Find and remove
    const tag = this.findTagByName(this.selectedTags, tagToRemove.text);
    if(tag == null) return;
    this.selectedTags.splice(tag.index, 1); 
    this.updateFiltersFormTagsValue();
  }
  public onValueChanged(value: string) {
    this.updateFiltersFormTagsValue();
    this.markAsTouched();
  }
  // #endregion
  
}
